// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__la1i7","colMin":"styles_colMin__1LMdc"};